
import useConfigurationSourceDataMap from "@/hooks/data/useConfigurationSourceDataMap";
import { createContext } from "react"

export interface IConfigurationSourceDataContext extends ReturnType<typeof useConfigurationSourceDataMap> {
}

export const ConfigurationSourceDataContext = createContext<IConfigurationSourceDataContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ConfigurationSourceDataContext;